/**
 * Push a deduplicated navigation event to dataLayer when Pipefy Tracking state updates.
 */

function trySubscribe() {
  const t = typeof window !== 'undefined' ? window.PipefyTracking : null;
  if (!t?.on || typeof t.getLeadData !== 'function') {
    return false;
  }

  let lastUrl = '';

  const maybePush = () => {
    if (!t.hasMarketingConsent?.()) {
      return;
    }
    let lead;
    try {
      lead = t.getLeadData();
    } catch {
      return;
    }
    const current = String(lead.current_page || '');
    const previous = String(lead.previous_page || '');
    if (!current || current === lastUrl) {
      return;
    }
    lastUrl = current;
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({
      event: 'pipefy_page_navigation',
      navigation: {
        previous_page: previous,
        current_page: current,
      },
    });
  };

  t.on(() => maybePush());
  maybePush();

  return true;
}

export function initPipefyDataLayerNavigation() {
  if (typeof window === 'undefined') {
    return;
  }
  if (trySubscribe()) {
    return;
  }
  let attempts = 0;
  const max = 40;
  const id = window.setInterval(() => {
    attempts += 1;
    if (trySubscribe() || attempts >= max) {
      window.clearInterval(id);
    }
  }, 50);
}
